import React from 'react'
import Header from '../../components/header'

const about = () => {
    return (
        <Header />
    )
}

export default about